module.exports = __webpack_public_path__ + "img/teaser-kv-bg.6b04b476.webp";